import type { TenantScope } from '@onefootprint/request-types/dashboard';
import { isSandboxOnly } from '@/components/roles/utils/scope-environments';

const decryptedData = (scope: TenantScope) => (scope.kind === 'decrypt' ? scope.data : undefined);

const isSameScope = (a: TenantScope, b: TenantScope) =>
  a.kind === b.kind && decryptedData(a) === decryptedData(b) && isSandboxOnly(a) === isSandboxOnly(b);

export default function getScopeDiff(oldScopes: TenantScope[], newScopes: TenantScope[]) {
  const commonScopes = oldScopes.filter(oldScope => newScopes.some(newScope => isSameScope(newScope, oldScope)));

  const oldScopesRemoved = oldScopes.filter(oldScope => !newScopes.some(newScope => isSameScope(newScope, oldScope)));

  const newScopesAdded = newScopes.filter(newScope => !oldScopes.some(oldScope => isSameScope(oldScope, newScope)));

  return {
    commonScopes,
    oldScopesRemoved,
    newScopesAdded,
  };
}
